import { useLocation } from 'react-router';
import { getSubCategoryFromPath } from '../../../../../../common/utils/employeeUtils.js';
import { EoeOneTimePasswordScene } from '../../../../../../components/EoeSubscriptionPairingScene/EoeOneTimePasswordScene.js';
import { useAuth } from '../../../../AuthProvider.js';

export const EoeOneTimePasswordPath = () => {
  const { pathname } = useLocation();
  const category = getSubCategoryFromPath(pathname);
  const { authenticatedUser } = useAuth();

  return (
    <EoeOneTimePasswordScene
      category={category}
      errors={authenticatedUser?.errors}
      saving={authenticatedUser?.saving || false}
    />
  );
};
